/**
 * @generated SignedSource<<5855a39767675cccec595afe71037b0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type heroArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  readonly " $fragmentType": "heroArticleArticle";
};
export type heroArticleArticle$key = {
  readonly " $data"?: heroArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "heroArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentItemRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "5c830976e0f6cc422caf4438b821f76e";

export default node;
